const MessageTypes = {
  SUBSCRIBE: 'subscribe',
  RESTORE_MESSAGES: 'restore_messages',
  SUBSCRIPTION_ACCEPTED: 'subscription_accepted',
  SEND_DIRECT_MESSAGE: 'send_direct_message',
  MESSAGE_RECEIVED: 'message_received',
  UPDATE_STATUS: 'update_status',
  USER_STATUS_UPDATED: 'user_status_updated',
  ORGANIZATION_UPDATED: 'organization_updated',
  ENTER_CHANNEL: 'enter_channel',
  ROOM_UPDATED: 'room_updated',
  SYSTEM_ALERT: 'system_alert',
  JOINED_ROOM: 'joined_room',
  ERR_NOT_SUBSCRIBED: 'err_not_subscribed',
};

module.exports = MessageTypes;



// WEBPACK FOOTER //
// ../node_modules/@flic-chat/js-sdk/src/message-types.js